import { URLS } from '@constants'
import {
  CopyControlPanelPayload,
  CREATEControlPanel,
  GETControlPanel,
  GETObjectDataParams,
  UPDATEControlPanel,
} from '@types'

import { commonAPI } from './common.api'

export const controlPanelApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchControlPanelList: build.query<GETControlPanel[], GETObjectDataParams>({
      query: params => ({
        url: URLS.FRONT_CFG + '/menu',
        params: {
          page: params?.page,
          size: params?.size,
          sort: params?.sort,
          searchPattern: params?.searchPattern,
        },
      }),
      providesTags: ['ControlPanels', 'AllConfigs'],
    }),
    fetchControlPanelById: build.query<GETControlPanel, string | void>({
      query: (id: string) => ({
        url: URLS.FRONT_CFG + `/menu/id/${id}`,
      }),
      providesTags: ['SingleControlPanel', 'AllConfigs'],
    }),
    createControlPanel: build.mutation<GETControlPanel, CREATEControlPanel>({
      query: elements => ({
        url: URLS.FRONT_CFG + '/menu',
        method: 'POST',
        body: elements,
      }),
      invalidatesTags: ['ControlPanels'],
    }),
    updateControlPanel: build.mutation<GETControlPanel, UPDATEControlPanel>({
      query: ({ elements }) => ({
        url: URLS.FRONT_CFG + '/menu',
        method: 'POST',
        body: elements,
      }),
      invalidatesTags: ['ControlPanels', 'SingleControlPanel'],
    }),
    copyControlPanel: build.mutation<GETControlPanel, CopyControlPanelPayload>({
      query: controlPanelData => ({
        url: URLS.FRONT_CFG + '/menu/copy',
        method: 'POST',
        body: controlPanelData,
      }),
      invalidatesTags: ['ControlPanels'],
    }),
    deleteControlPanel: build.mutation<GETControlPanel, string | number>({
      query: id => ({
        url: URLS.FRONT_CFG + `/menu/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ControlPanels'],
    }),
  }),
})

export const {
  useFetchControlPanelByIdQuery,
  useFetchControlPanelListQuery,
  useUpdateControlPanelMutation,
  useCopyControlPanelMutation,
  useDeleteControlPanelMutation,
  useCreateControlPanelMutation,
} = controlPanelApi
